import { ExpressionConstraint, OclExpressionConstraint } from '../constraint.js';
import { Schema } from '../schema.js';
import { OclConstraintDefinition, ProductDefinition } from '../DataSetService/yaml-models.js';


/***
 * Registry holding all ocl constraint applicable to all products in the system
 */
export class OclConstraintRegistry {
  private readonly constraints: {
    expression: ExpressionConstraint,
    definition: OclConstraintDefinition
  }[] = [];

  constructor(private schema: Schema) {
  }

  addConstraint(constraint: OclConstraintDefinition) {
    this.constraints.push(this.createExpressionConstraint(constraint));
  }

  getConstraintsForProductType(productType: ProductDefinition['type']): ExpressionConstraint[] {
    return this.constraints
      .filter(c => c.definition.type === productType)
      .map(c => c.expression);
  }

  private createExpressionConstraint(constraint: OclConstraintDefinition) {
    return {
      expression: new OclExpressionConstraint(constraint.oclExpression, constraint.errorMessage, this.schema),
      definition: constraint
    };
  }
}
